import { render } from "./SecondStep.vue?vue&type=template&id=49fbad3c&scoped=true"
import script from "./SecondStep.vue?vue&type=script&lang=js"
export * from "./SecondStep.vue?vue&type=script&lang=js"

import "./SecondStep.vue?vue&type=style&index=0&id=49fbad3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fbad3c"]])

export default __exports__